import pt_BR from './pt_BR';

const en_US: typeof pt_BR = {
  Home: {
    title: 'Access your account',
    button: 'ENTER',
    email_placeholder: 'Email',
    password_placeholder: 'Password',
  },
};

export default en_US;
